export const FETCH_SUPPORTED_AZURE_LANGUAGES = 'FETCH_SUPPORTED_AZURE_LANGUAGES';
export const FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS = 'FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS';
export const FETCH_SUPPORTED_AZURE_LANGUAGES_FAILURE = 'FETCH_SUPPORTED_AZURE_LANGUAGES_FAILURE';

export const FETCH_TRANSLATED_TEXT = 'FETCH_TRANSLATED_TEXT';
export const FETCH_TRANSLATED_TEXT_SUCCESS = 'FETCH_TRANSLATED_TEXT_SUCCESS';
export const FETCH_TRANSLATED_TEXT_FAILURE = 'FETCH_TRANSLATED_TEXT_FAILURE';

export const DETECT_LANGUAGE = 'DETECT_LANGUAGE';
export const DETECT_LANGUAGE_SUCCESS = 'DETECT_LANGUAGE_SUCCESS';
export const DETECT_LANGUAGE_FAILURE = 'DETECT_LANGUAGE_FAILURE';
